/**
 * @generated SignedSource<<9e9ca06acc4e34cfe74956792b0a1a4f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RemoveUserMutation$variables = {
  key: number;
};
export type RemoveUserMutation$data = {
  readonly removeUser: {
    readonly removed: ReadonlyArray<{
      readonly id: string;
    }>;
  } | null | undefined;
};
export type RemoveUserMutation = {
  response: RemoveUserMutation$data;
  variables: RemoveUserMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "key"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "key"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RemoveUserMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RemovedNodes",
        "kind": "LinkedField",
        "name": "removeUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RemovedNode",
            "kind": "LinkedField",
            "name": "removed",
            "plural": true,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RemoveUserMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RemovedNodes",
        "kind": "LinkedField",
        "name": "removeUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RemovedNode",
            "kind": "LinkedField",
            "name": "removed",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "deleteRecord",
                "key": "",
                "kind": "ScalarHandle",
                "name": "id"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "51c4d0c88de32ac72d905c5dc1975821",
    "id": null,
    "metadata": {},
    "name": "RemoveUserMutation",
    "operationKind": "mutation",
    "text": "mutation RemoveUserMutation(\n  $key: Int!\n) {\n  removeUser(key: $key) {\n    removed {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9c2d29184c9d9018799add689c9ab7fe";

export default node;
